<script>
// The shared footer keeps native SPA links in the storefront and full links in /promote/.
export default {
  functional: true,
  props: { to: { type: String, required: true }, external: Boolean },
  render(h, { props, data, children }) {
    if (props.external) return h('a', { ...data, attrs: { ...data.attrs, href: '/#' + props.to } }, children)
    return h('router-link', { ...data, props: { to: props.to } }, children)
  }
}
</script>
